import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import IconArrow from "../../../assets/images/icon-arrow-3.svg"
import IconClear from "../../../assets/images/icon-close-4.svg"


const Container = styled.div`
    width: 100%;
    margin-bottom: 16px;

    .label {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 16px;
    }

    .label-error {
        height: 16px;
        color: #F84242;
        font-size: 14px;
        font-weight: 300;
        margin-top: 4px;
    }
`;

const DropdownBox = styled.div`
    width: 100%;
    height: 50px;
    position: relative;
    border-radius: 13px;
    border: 1px solid #B5B5B5;
    transition: all 0.2s ease;

    .dropdown-content {
        width: calc(100% - 32px);
        height: 100%;
        padding: 0px 16px;
        cursor: pointer;

        &.disabled {
            cursor: default;
            background-color: #B3B3B333;
        }
    }

    &.error {
        border: 1px solid #F84242 !important;
    }

    &.open {
        /* border: 1px solid #FBE250; */
    }

    .label-placeholder {
        width: calc(100% - 60px);
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
    }

    .label-name {
        width: calc(100% - 60px);
        color: #25368D;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
    }

    .icon-box {
        margin-left: auto;
        margin-right: 0px;
        display: flex;
        justify-content: center;

        .image-arrow-box {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            padding-top: 2px;
            transition: all 0.3s ease;

            .image-arrow {
                transition: all 0.3s ease;

                &.open {
                    transform: rotateX(180deg);
                }
            }
        }

        .image-clear-box {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-color: #25368D;
            margin-top: 2px;
            cursor: pointer;

            .image-clear {
                width: 10px;
                height: 10px;  
            }
        }
    }
`;

const DropdownItemBox = styled.div`
    width: calc(100% - 16px);
    max-height: 200px;
    overflow-y: auto;
    padding: 8px;
    position: absolute;
    top: 54px;
    right: 0px;
    z-index: 9;
    border: 1px solid #B5B5B533;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 4px 0px #60606012;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 2px;

    .menu {
        height: 48px;
        min-height: 48px;
        padding: 0px 8px;
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            background-color: #FBE25099;
        }

        &.active {
            color: #25368D;
            background-color: #FBE250;
        }
    }

    .nodata {
        height: 48px;
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
    }
`;

function DropdownEvaluatorComponent({
    label,
    value,
    list,
    placeholder,
    labelError,
    isError,
    disable,
    hideClear,
    styleContainer,
    classContainer,
    styleDropdown,
    classDropdown,
    styleDropdownItemBox,
    classDropdownItemBox,
    onSelect,
}) {
    const [selectValue, setSelectValue] = useState(null);
    const [listItem, setListItem] = useState([]);
    const [open, setOpen] = useState(false)
    const dropdownRef = useRef(null)
    const buttonDropdownRef = useRef(null)

    useEffect(() => {
        const init = async () => {
            window.addEventListener('click', eventClickOutsideDropdown)
        };
        init();

        return () => {
            window.removeEventListener('click', eventClickOutsideDropdown)
        }
    }, [])

    useEffect(() => {
        const _list = Array.isArray(list) ? list : [];
        const _value = _list.find(x => x.value === value?.value);
        setSelectValue(_value);
        setListItem(_list);
    }, [value, list])

    useEffect(() => {
    }, [list])

    useEffect(() => {
        if (open && selectValue && dropdownRef.current) {
            const index = listItem.findIndex(x => x.value === selectValue?.value);
            if (index >= 0) {
                dropdownRef.current.scrollTo({
                    top: 50 * index,
                    behavior: "smooth",
                });
            }
        }
    }, [open])

    function eventClickOutsideDropdown(event) {
        if (dropdownRef.current
            && buttonDropdownRef.current
            && !dropdownRef.current.contains(event.target)
            && !buttonDropdownRef.current.contains(event.target)) {
            setOpen(false);
        }
    }

    function handleSelect(index) {
        if (disable) return;
        const detail = listItem[index]
        setSelectValue(detail)
        onSelect && onSelect(detail)
        setOpen(false)
    }
    function handleOpen() {
        if (disable) return;
        setOpen(!open)
    }
    function handleClear(event) {
        if (disable) return;
        event.preventDefault()
        // stopPropagation
        setSelectValue(null)
        onSelect && onSelect(null)
        setOpen(false)
    }

    return (
        <Container className={`${classContainer}`} style={{ ...styleContainer }}>
            {label && <div className="label">{label}</div>}
            <DropdownBox
                className={`${classDropdown} ${open ? "open" : ""} ${isError ? "error" : ""}`}
                style={{ ...styleDropdown }}
            >
                <div
                    ref={buttonDropdownRef}
                    className={`dropdown-content vertical-center ${disable ? "disabled" : ""}`}
                    onClick={handleOpen}
                >
                    {selectValue?.value ?
                        <div className="label-name text-overflow-dot" title={selectValue?.label}>{selectValue?.label}</div>
                        :
                        <div className="label-placeholder text-overflow-dot" title={placeholder || ""}>{placeholder || ""}</div>
                    }
                    <div className="icon-box">
                        {(!hideClear && selectValue?.value) &&
                            <div className={`image-clear-box content-center`} onClick={handleClear}>
                                <img className={`image-clear`} alt="img" src={IconClear} />
                            </div>
                        }
                        <div className={`image-arrow-box content-center`}>
                            <img className={`image-arrow ${open ? "open" : ""}`} alt="img" src={IconArrow} />
                        </div>
                    </div>
                </div>
                {open &&
                    <DropdownItemBox ref={dropdownRef} className={`${classDropdownItemBox}`} style={{ ...styleDropdownItemBox }}>
                        {listItem.map((_value, _index) => {
                            return (
                                <div key={_index} className={`menu ${_value.value === selectValue?.value ? "active" : ""} vertical-center`}
                                    title={_value.label}
                                    onClick={(e) => { handleSelect(_index) }}>
                                    <div className="text-overflow-dot">
                                        {_value.label}
                                    </div>
                                </div>
                            )
                        })}
                        {listItem.length === 0 &&
                            <div className="nodata content-center">ไม่มีข้อมูล</div>
                        }
                    </DropdownItemBox>
                }
            </DropdownBox>
            {/* <div className="label-error">{isError ? labelError : ""}</div> */}
        </Container>
    )
}

export default DropdownEvaluatorComponent;